import { toast } from "sonner";

// 2026-10-26: Svaret fra en invitation, sagt som det er. Før stod der
// "Invitation sendt", også når mailen blev afvist (fx et maildomæne, der ikke er
// sat op). Kunne den ikke sendes, kan linket kopieres og sendes på SMS/mail.
export function copyLink(link) {
  try {
    navigator.clipboard.writeText(link);
    toast.success("Linket er kopieret - det gælder i 72 timer");
  } catch (_e) {
    window.prompt("Kopiér linket:", link);
  }
}

export function inviteToast(data, email) {
  const d = data || {};
  if (d.delivered === false) {
    toast.error(`Mailen til ${email} blev ikke sendt${d.error ? ` (${d.error})` : ""}`, {
      description: d.link ? "Kopiér invitationslinket og send det selv (SMS eller mail)." : undefined,
      duration: 60000,
      action: d.link ? { label: "Kopiér link", onClick: () => copyLink(d.link) } : undefined,
    });
    return false;
  }
  if (d.sent_to && email && d.sent_to.toLowerCase() !== email.toLowerCase()) {
    toast.warning(`Mailen gik til ${d.sent_to} i stedet for ${email}`, {
      description: "Serveren sender al post til én adresse (EMAIL_OVERRIDE). Fjern den i Scaleway, når I er i drift.",
      duration: 20000,
    });
    return true;
  }
  toast.success(`Invitation sendt til ${email}`);
  return true;
}
